export default __webpack_public_path__ + "static/media/insecure-800w.0fde03eb.png";